import { createSlice } from '@reduxjs/toolkit';
import { HYDRATE } from 'next-redux-wrapper';

import type { HydrateAction } from 'redux-store';
import getProductsV3Thunk from 'redux-store/thunks/products/getProductsV3Thunk';

import type { ProductsInitialState } from './products.types';

const initialState: ProductsInitialState = {
  items: {},
  isLoading: false,
};

export const ProductsReducer = createSlice({
  name: 'products',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getProductsV3Thunk.pending, state => {
      state.isLoading = true;

      return state;
    });

    builder.addCase(getProductsV3Thunk.fulfilled, (state, action) => {
      state.isLoading = false;

      if (action.payload.success === true) {
        state.items = action.payload.products.reduce<
          ProductsInitialState['items']
        >((result, item) => {
          result[item.id] = item;

          return result;
        }, {});
      }

      return state;
    });

    builder.addCase(
      HYDRATE,
      (state, action: HydrateAction<ProductsInitialState>) => {
        return action.payload.productsV3;
      },
    );
  },
});

export const { actions, reducer } = ProductsReducer;
